import { inject, getCurrentInstance } from 'vue'

export function useLanguage() {
  const injectedStore = inject('languageStore', null)
  const instance = getCurrentInstance()
  const globalStore = instance?.appContext?.config?.globalProperties?.$languageStore
  const languageStore = injectedStore || globalStore

  const translate = (key, replacements) => {
    if (languageStore?.t) {
      return languageStore.t(key, replacements)
    }
    return key
  }

  return {
    languageStore,
    t: translate
  }
}

